<!--
  Grid:

  S-* = Only one instance
  M-* = More than one instances
  ² = Hidden for screenreader
  ³ = mobile view and screenreader only
  ⁴ = if no Aktionszeitraum exists, hide column completely
  ⁵ = always show button, even in column is hidden (will open confirmation dialogue)

  Visibility:
  - Nutzungsdauer: l-xl
  - Aktionszeitraum: l-xl
  - Status: s-xl


  Gebuchte Subscriptionen(h3) | Nutzungsdauer²   | Aktionszeitraum²⁴    | Status²
  ===========================================================================================
  Name(h4)                    | S-ND-Value²      | S-AZ-Value²⁴         | S-S-Icon²  [Details]
  S-Testphase
  S-Nutzungsdauer³   S-ND-Value³
  S-Aktionszeitraum³ S-AZ-Value³
  S-Status³          S-S-Icon³
  Mindestvertragslaufzeit
  [Reset promotion]⁵
  --------------------------------------------------------------------------------------------
  M-Instanz(h5)               | M-ND-Value²      | M-AZ-Value²⁴          | M-S-Icon²  [Details]
  M-Testphase
  M-Nutzungsdauer³   M-ND-Value³
  M-Aktionszeitraum³ M-AZ-Value³
  M-Status³          M-S-Icon³
-->

<template>
  <section v-if="items.length > 0" class="grid">
    <div class="row header">
      <div class="col-l-4 col-m-9 col-s-7 col-xs-12">
        <h3>
          <slot name="label" />
        </h3>
      </div>
      <div :class="hasAnyPromo ? 'col-l-3' : 'col-l-6'" class="col-m-hide col-s-hide col-xs-hide" aria-hidden="true">
        <span class="small-h3">
          {{ $t('common.booking_period_headline') }}
          <!-- #S819 -->
        </span>
      </div>
      <div v-if="hasAnyPromo" class="col-l-3 col-m-hide col-s-hide col-xs-hide" aria-hidden="true">
        <span class="small-h3">
          {{ $t('common.promotion_period_headline') }}
          <!-- #S820 -->
        </span>
      </div>
      <div class="col-l-2 col-m-3 col-s-4 col-xs-hide" aria-hidden="true">
        <span class="small-h3">
          {{ $t('common.status_headline') }}
          <!-- #S821 -->
        </span>
      </div>
    </div>

    <slot v-for="item in items" name="item" :item="item" />
  </section>
  <section v-else-if="!hideEmpty" class="grid">
    <h3>
      <slot name="label" />
    </h3>
    <slot name="empty" />
  </section>
</template>

<script>
export default {
  name: 'StockGrid',

  props: {
    items: {
      type: Array,
      required: true,
    },

    hasAnyPromo: {
      type: Boolean,
      required: false,
    },

    hideEmpty: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      isBusy: false,
      confirmation: null,
    };
  },

  provide() {
    return {
      grid: this,
    };
  },
};
</script>
